import AsHtml from "@ww-digital/applanga-js/dist/React";
import { get as compile } from "@ww-digital/applanga-js/dist/Text";

export default function t(key, interpolations) {
  const rawValue = window.ww.lang[key] || "";

  if (window.window.location.search.indexOf("showKeys") > -1) {
    return key;
  }

  return compile(rawValue, interpolations);
}

export { compile, AsHtml };
